<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";
  import TextAccordion from "$lib/molecules/TextAccordion.svelte";

  // Get the block data
  export let blok;
</script>

<section class="faq-section mx-auto" use:storyblokEditable={blok}>
  <h1 class="main-heading type:h2">{blok.heading}</h1>
  <div class="faq-list">
    <TextAccordion blok={{ component: "textAccordion", items: blok.questions[0].items }} />
  </div>
</section>

<style lang="postcss">
  .faq-section {
    margin-top: 3rem;
    padding-top: 4rem;
    padding-bottom: 3rem;
    padding-left: 1.25rem;
    padding-right: 1.25rem;
    background-color: #eae8e1;

    @media (min-width: 768px) {
      margin-top: 5rem;
      padding-top: 5rem;
    }
  }

  .faq-list {
    max-width: 640px;
    margin: 0 auto;
  }

  .main-heading {
    margin-bottom: 4rem;
    text-align: center;
  }
</style>
